import { ModalElement } from './modal-element.js';

ModalElement.defineCustomElement();

export { ModalElement };
